/**
 * useAIPhishing Hook
 *
 * Phishing check with caching per message via React Query.
 */

import { useQuery } from '@tanstack/react-query';
import { api, EmailAIPhishingResult } from '@/lib/api';
import { errorMessage } from '../types';

export function useAIPhishing(
  accountId: string | undefined,
  messageId: string | undefined,
  enabled: boolean = false,
) {
  const queryResult = useQuery({
    queryKey: ['email', 'ai', 'phishing', messageId],
    queryFn: async () => {
      if (!accountId || !messageId) throw new Error('Missing params');
      return api.aiPhishingCheck(accountId, messageId);
    },
    enabled: !!accountId && !!messageId && enabled,
    staleTime: Infinity, // Cache per message permanently
  });

  return {
    result: queryResult.data ?? (null as EmailAIPhishingResult | null),
    loading: queryResult.isLoading,
    error: errorMessage(queryResult.error),
  };
}
